__turbopack_context__.v({
  "className": "inter_8e82cbd2-module__zneHAW__className",
});
